import React from "react";
import Utils from "../utils/utils";
import LoadingComp from "../components/LoadingComp";
import ProjectDashboard from "../components/Projects/ProjectDashboard";

const Projects = ({ user }) => {
  const createdAt = new Date(user?.createdAt).getTime();
  const isMoreThan90 = createdAt && Utils.getDuration(createdAt) < 90;

  if (!user || !user.name) {
    return (
      <div className=" overflow-y-auto overflow-x-hidden space-y-4 h-[calc(100vh-65px)]">
        <LoadingComp message={"Loading Projects"} />
      </div>
    );
  }

  return (
    <div className="shadow-none p-4 overflow-y-auto overflow-x-hidden space-y-4 h-[calc(100vh-65px)]">
      <div className="flex w-full">
        {isMoreThan90 ? (
          <div className="animate-fade-in transition-all duration-500 ease-in-out transform scale-100 bg-pink-50 border-l-4 border-pink-500 text-pink-700 p-4 rounded-lg shadow-md">
            <h3 className="font-semibold text-lg">🌱 Keep Growing!</h3>
            <p className="mt-1">
              The <span className="font-semibold">Projects Section</span> will
              be enabled for you once you complete
              <span className="font-semibold">
                {" "}
                30% of your course duration.
              </span>{" "}
              Keep learning! 🚀
            </p>
          </div>
        ) : (
          <ProjectDashboard props={{ user }} />
        )}
      </div>
    </div>
  );
};

export default Projects;
